import {Router, ActivatedRoute} from '@angular/router';
import * as _ from 'lodash';
import {API_CALL_ERROR} from './../../../store/action';
import {ApiService} from './../../../api/api.service';
import {AppInjector} from './../../../app-injector';
import {takeEvery, put} from 'redux-saga/effects';
import {
  CREATE_DELIVERYS_SUCCEEDED,
  CREATE_DELIVERYS_REQUESTED, ADD_DATA_DELIVERY, SEARCH_AND_ADD_DATA_DELIVERY,
} from './create.actions';
import {UtilityService} from "../../../common/services/utility/utility.service";
import {NotificationService} from "../../../common/services/notification/notification.service";
import {WIZARD_PRODUCT_SKIP_COMPLETED} from "../../product/wizard/wizard.actions";
import {COLLECTION_COMP} from "../../collection/collection.const";
import {ORDER_COMP} from "../../order/order.const";
import Redirect from "../../../models/Redirect";
import {DELIVERY_COMP} from "../delivery.const";
import store from "../../../store/store.module";
import {GET_COLLECTION_REQUESTED} from "../../collection/edit/edit.actions";

function* createDeliverys(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.delivery.bulkCreate(action.data).toPromise();
    const router = AppInjector.get(Router);
    yield put({
      type: CREATE_DELIVERYS_SUCCEEDED, data: results.data.map(s => {
        if (!_.isUndefined(s.details)) {
          delete s.details;
        }
        return s;
      })
    });
    AppInjector.get(NotificationService).show('success', 'Delivery request created', 5000);
    let redirect = 'delivery/list';
    if (action.redirect) {
      redirect = action.redirect;
    }
    AppInjector.get(UtilityService).redirectAndReset(redirect);
  } catch (e) {
    yield put({type: API_CALL_ERROR, error: e});
  }
}

function* watchCreateDeliveryRequest() {
  yield takeEvery(CREATE_DELIVERYS_REQUESTED, createDeliverys);
}

function* addDataDeliverys(action) {
  try {
    const router = AppInjector.get(Router);
    if (action.com === COLLECTION_COMP) {
      AppInjector.get(UtilityService).nextPageWithReferer(['delivery/request'], new Redirect(action.redirect, {}));
    } else if (action.com === ORDER_COMP) {
      let redirect = 'delivery/request';
      router.navigate([redirect]);
    }
  } catch (e) {
    yield put({type: API_CALL_ERROR, error: e});
  }
}

function* watchAddDataDeliveryRequest() {
  yield takeEvery(ADD_DATA_DELIVERY, addDataDeliverys);
}

function* createAndAddDataDeliverys(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = action.data.content;
    if (action.data.object_type === 'collection') {
      result = yield api.collection.getItemById(action.data.object_id).toPromise();
    } else if (action.data.object_type === 'product') {
      result = yield api.product.getItemById(action.data.object_id).toPromise();
    }
    yield put({
      type: ADD_DATA_DELIVERY, com: DELIVERY_COMP, data: {
        'object_type': action.data.object_type,
        'object_id': action.data.object_id,
        'delivery_type': action.data.delivery_type,
        'content': result
      }
    });
  } catch (e) {
    yield put({type: API_CALL_ERROR, error: e});
  }
}

function* watchCreateAndAddDataDeliveryRequest() {
  yield takeEvery(SEARCH_AND_ADD_DATA_DELIVERY, createAndAddDataDeliverys);
}

export default [watchCreateDeliveryRequest, watchAddDataDeliveryRequest, watchCreateAndAddDataDeliveryRequest];
